import React from 'react';
import { Icon } from 'antd';


const CartSvg = () => (
    <svg fill="currentColor" width="1em" height="1em" viewBox="0 0 28 28">
        <path
            d="M25.3,9.6c-.1-.2-.4-.3-.6-.4L6.9,7.1l-.8-4.2c0-.4-.4-.7-.8-.7h-3.3c-.5,0-.9.4-.9.9s.4.9.9.9h2.5l3,16.6c-1.5.2-2.7,1.4-2.7,3s1.3,3,3,3,3-1.3,3-3-.1-.9-.3-1.3h7c-.2.4-.3.8-.3,1.3,0,1.6,1.3,3,3,3s3-1.3,3-3-1.3-2.9-2.9-3c0,0,0,0,0,0h-11l-.2-1.1h13.3c.4,0,.7-.3.8-.6l2.2-8.4c0-.2,0-.5-.1-.7ZM7.9,24.7c-.7,0-1.3-.6-1.3-1.3s.6-1.3,1.3-1.3,1.3.6,1.3,1.3-.6,1.3-1.3,1.3ZM20.3,24.7c-.7,0-1.3-.6-1.3-1.3s.6-1.3,1.3-1.3,1.3.6,1.3,1.3-.6,1.3-1.3,1.3ZM21.8,17.6h-13l-1.6-8.7,16.3,1.9-1.8,6.8Z"/>

    </svg>
);

const CartIcon = props => {

    if (props.loading) {
        return <Icon type="loading"/>;
    }

    return <Icon component={CartSvg}/>;
};


export default CartIcon;